import { Flex } from "@mantine/core";
import { withErrorBoundary } from "react-error-boundary";
import { WidgetContainer } from "@/sales-tools/widgets";
import { RenderError } from "@/shared-utils";
import { Transcript } from "@/transcript/Transcript";

const TranscriptHandled = withErrorBoundary(Transcript, { FallbackComponent: RenderError });

interface WorkspaceContentLeftSidebarSlotProps {
    showRealtimeTranscript: boolean;
    taskStartTimeInMs: number;
}

export function WorkspaceContentLeftSidebarSlot({
    showRealtimeTranscript,
    taskStartTimeInMs,
}: WorkspaceContentLeftSidebarSlotProps) {
    return (
        <Flex pos={"absolute"} inset={0}>
            {showRealtimeTranscript ? <TranscriptHandled taskStartTimeInMs={taskStartTimeInMs} /> : <WidgetContainer />}
        </Flex>
    );
}
